import React from 'react';
import { Header } from './components/Header';
import { CampaignHero } from './components/CampaignHero';
import { BioSection } from './components/BioSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <CampaignHero data-id="element-2" />
      <BioSection data-id="element-3" />
      <Footer data-id="element-4" />
    </div>;
}